import React from "react";

import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import Checkbox from "hoc/Checkbox";
import CustomField from "components/Form/CustomField";
import InputSearch from "components/Form/InputSearch";
import { debounce } from "utils";

import { Form, Schema } from "rsuite";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(40, "The maximum is only 40 characters."),
});


const Filters = ({ onChange, value, isMobile }) => {
    return (
        <StyledForm
                layout="inline"
                isMobile={isMobile}
                onChange={debounce(onChange, 300)}
                formDefaultValue={{
                    ...value,
                    show_unallocated_numbers: true,
                    show_allocated_numbers: true,
                    show_test_numbers: true,
                    show_block_allocation_numbers: true,
                    show_only_block_allocation_numbers: false
                }}
                model={filtersModel}
            >
                {isMobile ? <>
                    <FiltersLabel>Show numbers:</FiltersLabel>
                    <CheckboxGrid>
                        <Box><Checkbox name="show_unallocated_numbers" checked={value.show_unallocated_numbers} defaultChecked={true}>Unallocated</Checkbox></Box>
                        <Box><Checkbox name="show_allocated_numbers" checked={value.show_allocated_numbers} defaultChecked={true}>Allocated</Checkbox></Box>
                        <Box><Checkbox name="show_test_numbers" checked={value.show_test_numbers} defaultChecked={true}>Test</Checkbox></Box>
                        <Box><Checkbox name="show_block_allocation_numbers" checked={value.show_block_allocation_numbers} defaultChecked={true}>Blocked</Checkbox></Box>
                        <Box><Checkbox name="show_only_block_allocation_numbers" checked={value.show_only_block_allocation_numbers} defaultChecked={false}>Only blocked</Checkbox></Box>
                    </CheckboxGrid>
                    <SearchField>
                        <CustomField
                            name="str"
                            accepter={InputSearch}
                            errorPlacement="topRight"
                            placeholder="Number search"
                            style={{ width: "100%" }}
                        />
                    </SearchField>
                </> : <>
                    <span style={{ position: "relative", top: 8, margin: 0 }}>Show numbers:</span>
                    <Box><Checkbox name="show_unallocated_numbers" checked={value.show_unallocated_numbers} defaultChecked={true}>Unallocated</Checkbox></Box>
                    <Box><Checkbox name="show_allocated_numbers" checked={value.show_allocated_numbers} defaultChecked={true}>Allocated</Checkbox></Box>
                    <Box><Checkbox name="show_test_numbers" checked={value.show_test_numbers} defaultChecked={true}>Test</Checkbox></Box>
                    <Box><Checkbox name="show_block_allocation_numbers" checked={value.show_block_allocation_numbers} defaultChecked={true}>Blocked</Checkbox></Box>
                    <Box><Checkbox name="show_only_block_allocation_numbers" checked={value.show_only_block_allocation_numbers} defaultChecked={false}>Only blocked</Checkbox></Box>
                    <br />
                    <CustomField
                        name="str"
                        accepter={InputSearch}
                        errorPlacement="topRight"
                        placeholder="Number search"
                        style={{ width: 220 }}
                    />
                </>}
            </StyledForm>
    );
};

export default FormHOC(Filters, filtersModel, 300);

const Box = styled.div`
    display: inline-block;
`;

const StyledForm = styled(Form)`
    margin-bottom: ${props => props.isMobile ? 12 : -25}px;

    ${props => props.isMobile && `
        && {
            display: block;
        }

        && > * {
            margin-right: 0;
        }
    `}
`;

const FiltersLabel = styled.span`
    display: block;
    margin-bottom: 4px;
    font-weight: 600;
`;

const CheckboxGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 8px;
    row-gap: 0;
    margin-bottom: 8px;

    > div {
        min-width: 0;
    }

    > div .rs-form-group {
        margin: 0;
    }

    > div .rs-checkbox {
        margin-left: 0;
        white-space: nowrap;
    }

    @media (max-width: 360px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

const SearchField = styled.div`
    display: block;
    width: 100%;

    .rs-form-group,
    .rs-form-control-wrapper,
    .rs-input-group,
    .rs-input {
        width: 100% !important;
        margin: 0;
    }
`;
